import "../Input/index.scss";

import { NANP_ISO2_LIST } from "constants/index";
import { formatPhoneNumber, onlyAllowNumber, parsePhoneNumber } from "helpers/utils";
import React, { forwardRef, useEffect, useState } from "react";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  hasError?: boolean;
  borderRightStraight?: boolean;
  borderLeftStraight?: boolean;
  iso2?: string;
  international?: boolean;
  withCountryCallingCode?: boolean;
  value: string;
  onChange: (string) => void;
};

const PhoneInputComponent = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const {
    hasError,
    borderRightStraight,
    borderLeftStraight,
    iso2,
    international = true,
    withCountryCallingCode = false,
    value = "",
    onChange: onChangeProps,
  } = props;

  const [val, setVal] = useState("");

  useEffect(() => {
    if (NANP_ISO2_LIST.includes(iso2)) {
      setVal(formatPhoneNumber(value, "+1 NNN-NNN-NNNN"));
    } else {
      setVal(value);
    }
  }, [value]);

  const onChange = (e) => {
    let inputVal = e.target.value;
    if (NANP_ISO2_LIST.includes(iso2)) {
      if (parsePhoneNumber(inputVal)?.length > 12) return;
      onChangeProps(parsePhoneNumber(inputVal));
      setVal(formatPhoneNumber(inputVal, "+1 NNN-NNN-NNNN"));
    } else {
      if (inputVal?.length && !inputVal?.includes("+")) inputVal = `+${inputVal}`;
      onChangeProps(inputVal);
      setVal(inputVal);
    }
  };

  return (
    <div
      className={
        "base-input" +
        `${hasError ? " error" : ""}` +
        `${borderRightStraight ? " rangeFrom" : ""}` +
        `${borderLeftStraight ? " rangeTo" : ""}`
      }
    >
      {/* <PhoneInput
        country={iso2}
        international={international}
        withCountryCallingCode={withCountryCallingCode}
        value={value}
        onChange={onChange}
      /> */}
      <input ref={ref} value={val} onChange={onChange} onKeyDown={onlyAllowNumber} />
    </div>
  );
});

export default PhoneInputComponent;
